module.exports = __webpack_public_path__ + "img/operate.3c3ab7b4.png";